<template>
  <div>
    <inquiryForm
      :loading="loading"
      :formTitle="formTitle"
      @submit="save"
      @closeModal="closeModal"
    />
  </div>
</template>

<script>
import inquiryForm from "./inquiryForm.vue";
export default {
  components: {
    inquiryForm,
  },
  props: {
    code: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      formTitle: `ایجاد ${this.$lang.profileLang.inquiryPerson}`,
    };
  },

  methods: {
    closeModal() {
      this.$emit("modal-end-up");
    },
    async save(payload) {
      try {
        this.loading = true;
        const url =
          this.$config.api_url +
          this.$config.profile.person_inquiry.replace("{0}", this.code);
        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);
        this.closeModal();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
